<template>
  <b-modal
    id="buy-modal"
    title="Complete configuration"
    size="lg"
    centered
  >
    <template #modal-header>
        <div class="w-100">
            <div class="text-center xs-text uppercase">Confirm your order</div>
        </div>
    </template>

    <h3 class="text-center mb-4">50% payment</h3>

    <div class="text-center" style="max-width: 350px; margin: auto">
        <p>Pay the 50% of the order value now. Our atelier will check your configuration and confirm the final details before commencing the build.</p>
        <p>Once the builde is complete, we will contact you to confirm delivery details and take the final 50% payment.</p>

        <button class="btn btn-outline-primary mt-2 mb-3" @click="addToCart">pay 50% now</button>
    </div>

    <template #modal-footer>
        <div class="w-100 text-center">
            <div class="closer" @click="$root.$emit('bv::hide::modal', 'buy-modal')">X</div>
        </div>
    </template>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  name: "save-modal",
  data() {
    return {
      download_pdf: false,
      dealer: null,
      dealers: [
        { text: "Passoni", value: 1 },
      ],
    };
  },
  mounted() {
      let t = this;
      axios
        .get("/api/mtm-configurator/dealers")
        .then((res) => {
          this.dealers = res.data;
        })
        .catch(function (error) {
          if (error.response) {
            t.$emit('set-error', 'Cannot load dealers');
          }
        });
  },
  props: ["loginEmail"],
  computed: {
    loginEmailInput: {
      get: function () {
        return this.loginEmail;
      },
      set: function (e) {
        this.$emit("set-login-email", e);
      },
    },
  },
  methods: {
    addToCart: function() {
        document.getElementById('add-to-cart-form').submit();
    }
  },
};
</script>
